<script>import MenuCategoryContainer from "../components/containers/MenuCategoryContainer.svelte";
import ReOrderableList from "../components/containers/ReOrderableList.svelte";
import LabeledLauncher from "../components/launchers/LabeledLauncher.svelte";
import { dictionaries, Locale, lookupMessage, toLocale } from "../i18n/index.js";
export let lang = Locale.en;
$:
  locale = toLocale(lang);
export let launchers;
const buildMenu = (locale2, launchers2) => {
  let dictionary = dictionaries[locale2];
  let menu2 = [];
  if (launchers2 && launchers2.length > 0) {
    const sensorLaunchers = launchers2.filter((ll) => ll.group === "sensor");
    const observationLaunchers = launchers2.filter(
      (ll) => ll.group === "observation"
    );
    const modellingLaunchers = launchers2.filter(
      (ll) => ll.group === "modelling"
    );
    modellingLaunchers.splice(
      modellingLaunchers.length,
      0,
      ...launchers2.filter((ll) => ll.name === "process-lfr")
    );
    const mapFeatureLaunchers = launchers2.filter(
      (ll) => ll.name === "com__tlmapp__tlmd__modules__poi__PoiMapViewer"
    );
    const outputLaunchers = launchers2.filter(
      (ll) => ll.name === "dlg-export"
    );
    outputLaunchers.splice(
      outputLaunchers.length,
      0,
      ...launchers2.filter((ll) => ll.name === "dlg-reports")
    );
    const setupLauncher = launchers2.filter((ll) => ll.name === "domain-lfr");
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "organisation-lfr")
    );
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "user-lfr")
    );
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "role-lfr")
    );
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "group-lfr")
    );
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "substance-lfr")
    );
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "installation-lfr")
    );
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "source-lfr")
    );
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "poi-lfr")
    );
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "project-lfr")
    );
    setupLauncher.splice(
      setupLauncher.length,
      0,
      ...launchers2.filter((ll) => ll.name === "settings")
    );
    if (sensorLaunchers.length > 0) {
      menu2.push({
        name: "sensor",
        label: lookupMessage("common.ui.menu.main.sections.sensors", dictionary) ?? "Sensors",
        icon: "glyph-heartbeat",
        launchers: sensorLaunchers.map((ll) => ({
          name: ll.name,
          label: ll.label,
          icon: mapIcon(ll.icon),
          hasHandler: ll.handler != null
        }))
      });
    }
    if (observationLaunchers.length > 0) {
      menu2.push({
        name: "observation",
        label: lookupMessage("common.ui.menu.main.sections.observations", dictionary) ?? "Observations",
        icon: "glyph-street-view",
        launchers: observationLaunchers.map((ll) => ({
          name: ll.name,
          label: ll.label,
          icon: mapIcon(ll.icon),
          hasHandler: ll.handler != null
        }))
      });
    }
    if (modellingLaunchers.length > 0) {
      menu2.push({
        name: "modelling",
        label: lookupMessage("common.ui.menu.main.sections.modelling", dictionary) ?? "Modelling",
        icon: "icon-plume",
        launchers: modellingLaunchers.map((ll) => ({
          name: ll.name,
          label: ll.label,
          icon: mapIcon(ll.icon),
          hasHandler: ll.handler != null
        }))
      });
    }
    if (mapFeatureLaunchers.length > 0) {
      menu2.push({
        name: "mapFeatures",
        label: lookupMessage("common.ui.menu.main.sections.mapFeatures", dictionary) ?? "Map Features",
        icon: "glyph-map-marker",
        launchers: mapFeatureLaunchers.map((ll) => ({
          name: ll.name,
          label: ll.label,
          icon: mapIcon(ll.icon),
          hasHandler: ll.handler != null
        }))
      });
    }
    if (outputLaunchers.length > 0) {
      menu2.push({
        name: "output",
        label: lookupMessage("common.ui.menu.main.sections.output", dictionary) ?? "Export & Report",
        icon: "glyph-download-cloud",
        launchers: outputLaunchers.map((ll) => ({
          name: ll.name,
          label: ll.label,
          icon: mapIcon(ll.icon),
          hasHandler: ll.handler != null
        }))
      });
    }
    if (setupLauncher.length > 0) {
      menu2.push({
        name: "setup",
        label: lookupMessage("common.ui.menu.main.sections.setUp", dictionary) ?? "Set up",
        icon: "glyph-edit",
        launchers: setupLauncher.map((ll) => ({
          name: ll.name,
          label: ll.label,
          icon: mapIcon(ll.icon),
          hasHandler: ll.handler != null
        }))
      });
    }
  }
  return menu2;
};
const mapIcon = (legacyIcon) => {
  switch (legacyIcon) {
    case "icon-flag-empty":
      return "glyph-street-view";
    case "icon-sensor":
      return "glyph-heartbeat";
    case "icon-cog":
      return "glyph-cog";
    case "icon-user":
      return "glyph-user";
    case "icon-users":
      return "glyph-user-group";
    case "icon-location":
      return "glyph-map-marker";
  }
  return legacyIcon;
};
$:
  menu = buildMenu(locale, launchers);
</script>

<div class="top-menu">
  <ReOrderableList type="primary">
    {#each menu as category}
      <div class="category">
        <MenuCategoryContainer
          name={category.name}
          label={category.label}
          icon={category.icon}
        >
          {#each category.launchers as launcher}
            <LabeledLauncher
              name={launcher.name}
              label={launcher.label}
              icon={launcher.icon}
            />
          {/each}
        </MenuCategoryContainer>
      </div>
    {/each}
  </ReOrderableList>
</div>

<style>
  div.top-menu {
    padding: 1rem;
  }
  div.category {
    margin-bottom: 0.75rem;
  }
</style>
